import { render, staticRenderFns } from "./MediaLightBox.vue?vue&type=template&id=5a26cecc&scoped=true&"
import script from "./MediaLightBox.vue?vue&type=script&lang=js&"
export * from "./MediaLightBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a26cecc",
  null
  
)

export default component.exports